'use strict';

module.exports = '<img class="ad-img-profile-pic" src="<%= userImg %>" />';



//////////////////
// WEBPACK FOOTER
// ./~/ad-theme-customizer-client/src/components/templates/icons/user-img-icon.tpl.js
// module id = 45
// module chunks = 0